import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type SnackbarType = 'success' | 'info' | 'warning' | 'error' | undefined

export interface SnackbarInputReduxState {
    message: string | object | unknown
    type: SnackbarType
}
export interface SnackbarReduxState {
    message: string
    type: SnackbarType
    open: boolean
}

const initialState: SnackbarReduxState = {
    message: '',
    type: 'success',
    open: false,
}

export const snackbarSlice = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {
        displayMessage: (state, action: PayloadAction<Omit<SnackbarInputReduxState, 'open'>>) => {
            const msg =
                typeof action.payload.message === 'string'
                    ? action.payload.message
                    : action.payload.message instanceof Error
                    ? action.payload.message.message
                    : 'Unknown error'
            state.message = msg
            state.type = action.payload.type
            state.open = true
        },
        closeMessage: (state) => {
            state.open = false
        },
    },
})
